<template>



<v-form v-model="valid">
  <v-container>

    <v-app-bar
      app
      color="grey lighten-4"
    >

     <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

          <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://conciergepad-images.s3.amazonaws.com/concierge_logo.png"
          transition="scale-transition"
          width="250"
        />
        </div>

    
         </v-app-bar>


<v-navigation-drawer
        v-model="drawer"
        :color="color"
        :expand-on-hover="expandOnHover"
        :mini-variant="miniVariant"
        :right="right"
        :permanent="permanent"
        :src="bg"
        absolute
        temporary
        dark
      >
        <v-list
          dense
          nav
          class="py-0"
        >
          <v-list-item two-line :class="miniVariant && 'px-0'">

            <v-list-item-content>
              <v-list-item-title>Menu</v-list-item-title>
              <v-list-item-subtitle>Please select link from sidebar</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item
            v-for="item in itemsDrawer"
            :key="item.title"
            link
            @click="$router.push({ path: item.route })"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

    <v-alert type="success" v-model="validSurvey">
      Successful Survey. Close window.
    </v-alert>

     <v-alert type="error" v-model="invalidSurvey">
     Invalid Survey.  Please try again.
    </v-alert>


      <survey :survey="survey"></survey>

    </v-container>
  </v-form>

</template>

<script>
//In your VueJS App.vue or yourComponent.vue file add these lines to import
import * as SurveyVue from 'survey-vue'
import 'bootstrap/dist/css/bootstrap.css';

var Survey = SurveyVue.Survey
Survey.cssType = "bootstrap";
Survey.navigationButton = "btn btn-success";

//If you want to add custom widgets package
//Add these imports
import * as widgets from "surveyjs-widgets";
import axios from 'axios';
import moment from 'moment-timezone';

//And initialize widgets you are want ti use
widgets.select2(SurveyVue);
widgets.inputmask(SurveyVue);
widgets.jquerybarrating(SurveyVue);
widgets.nouislider(SurveyVue);
widgets.select2tagbox(SurveyVue);
widgets.sortablejs(SurveyVue);
widgets.ckeditor(SurveyVue);
widgets.autocomplete(SurveyVue);
widgets.bootstrapslider(SurveyVue);

export default {
  name: 'app',
  components: {
    Survey,

  },
  data () {
    
    return {
        drawer: false,
        itemsDrawer: [
          { title: 'Add Student', icon: 'mdi-account-plus', route:'profile' },
          { title: 'Send Invite', icon: 'mdi-send', route:'#' },
          { title: 'Logout', icon: 'mdi-logout', route:'login' },
        ],
        color: 'primary',
        colors: [
          'primary',
          'blue',
          'success',
          'red',
          'teal',
        ],
        valid: true,
        inviteSent: true,
        inviteButton: true,
        right: false,
        clipped: true,
        permanent: false,
        miniVariant: false,
        expandOnHover: false,
        background: false,
        survey: '',
        pId: '',
        jwsToken: '',
        studentId: '',
        studentName: '',
        companyName: '',
        parentName: '',
        entryTime:null,
        signatureUrl:'signatureUrl',
        validSurvey: false,
        invalidSurvey: false,
        json:{},
        questionValue: '',
        pushToken: '',
        
    }
  },
  mounted: function() {

   console.log('App mounted!');

   
                
  this.studentId = this.$route.params.id;
  this.companyName = this.$route.params.uuid;
  this.parentName = this.$route.params.parent;
  this.studentName = this.$route.params.name;
  this.pushToken = this.$route.params.pushToken;

  console.log(this.studentId);
  console.log(this.companyName);
  console.log(this.parentName);

  console.log("Company: " + this.companyName);


   

   if (this.companyName == "") {

     console.log("IN COMPANY LOGIC");

     this.$alert("Company NOT assigned, cannot load","Error","error");

   }

   else if (this.studentName == "") {

    console.log("IN STUDENT LOGIC");

     this.$alert("Student NOT assigned, cannot load","Error","error");

   } else {

     console.log("IN SURVEY LOGIC");

      this.getSurvey(this.companyName);
      //this.getSurvey("2ccb94a2-1369-4b21-9535-c0a769b67f86");

   }

   


    var jsonSurvey = {
     elements: [

     
      {type: "text",name: "studentId", title: "Student ID (Read Only)", readOnly: true,
      
        validators: [
                        {
                            type: "expression",
                            expression: "{companyName}",
                            includeIntoResult: true
                        },
                         {
                            type: "expression",
                            expression: "{entryTime}",
                            includeIntoResult: true
                        },
                        {
                            type: "expression",
                            expression: "{signatureUrl}",
                            includeIntoResult: true
                        },
                        {
                            type: "expression",
                            expression: "{studentName}",
                            includeIntoResult: true
                        },
                        {
                            type: "expression",
                            expression: "{pushToken}",
                            includeIntoResult: true
                        }
                    ]
      },
       {
        type: "radiogroup",
         choices: [
          {
            value: "N",
            text: "No"
           },
        ],
        colCount: 0,
        hasOther: true,
        isRequired: true,
        name: "temp",
        otherText: "Yes",
        title:  "Does your child have or have they had a fever above 100.4 F. within the past 24 hours?"
         },
      {type: "boolean",name: "cough", title: "Does your child have a new onset or worsening cough or shortness of breath?"},
      {type: "html", name: "info", html: "<b>Does your child have any of the symptoms below?</b>"},
      {type: "boolean",name: "fever", title: "Chills?", isRequired: true},
      {type: "boolean",name: "sore", title: "Sore throat?", isRequired: true},
      {type: "boolean",name: "nose", title: "Runny Nose or nasal congestion", isRequired: true},
      {type: "boolean",name: "headache", title: "Headache?", isRequired: true},
      {type: "boolean",name: "fatigue", title: "Fatigue, muscle or body aches?", isRequired: true},
      {type: "boolean",name: "stomach", title: "Diarrhea, Nausea and/or vomiting", isRequired: true},
      {type: "boolean",name: "smell", title: "New onset loss of taste/smell", isRequired: true},
     
     
      {type: "boolean",name: "pastexp", title: "Has your child recently been diagnosed with COVID-19?", isRequired: true},
      {type: "boolean",name: "contact", title: "Has anyone in your household recently been in contact with someone diagnosed with COVID-19?", isRequired: true},
      {type: "boolean",name: "feverTime", title: "Has anyone in your household recently been in contact with someone with COVID-19 symptoms?", isRequired: true},
      {type: "boolean",name: "travel", title: "Due to the recent addition of the Chicago Department of Health Emergency Travel Order, have you traveled to any of the following locations with the past week? Alabama, Arkansas, Arizona, California, Florida, Georgia, Idaho, Iowa, Kansas, Louisiana, Mississippi, Missouri, Nebraska, North Carolina, North Dakota, South Carolina, South Dakota, Nevada, Oklahoma, South Carolina, Tennessee, Texas, Utah, or Puerto Rico.", isRequired: true},
     

      
        {type: "text",name: "parentName", title: "Full Name (adding your name to this field will serve as an electronic signature acknowledging the below information is true and correct).", isRequired: true}
      ]
    
      
    };


 console.log("here is json");
 console.log(JSON.stringify(jsonSurvey));

    
    
    //Create the model and pass it into VueSJ Survey component
    //var model = new SurveyVue.Model(json)
    //model.onComplete();
    //You may set model properties
    //model.mode="display"

   
    


  },
  
   methods: {

 
    getSurvey:function(companyName) {

      axios.get('https://api.conciergepadedu.com/api/Creators/GetSurvey/' +  companyName).then(response => {

      if (response.data.error) {

          console.log("ERROR");
          console.log(response.data.error)
          this.$alert("Error survey cannot load","Error","error");


      } else {

        console.log(response.data);

        this.json = response.data.jsoN_TEXT
        this.questionValue = response.data.questioN_NO

        console.log("Here is the text bro");
        console.log(JSON.stringify(this.json));




     /*var jsonSurvey = {
     elements: [
      {type: "text",name: "studentId", title: "Student ID (Read Only)", readOnly: true,
      
        validators: [
                        {
                            type: "expression",
                            expression: "{companyName}",
                            includeIntoResult: true
                        },
                         {
                            type: "expression",
                            expression: "{entryTime}",
                            includeIntoResult: true
                        },
                        {
                            type: "expression",
                            expression: "{signatureUrl}",
                            includeIntoResult: true
                        },
                        {
                            type: "expression",
                            expression: "{studentName}",
                            includeIntoResult: true
                        },
                        {
                            type: "expression",
                            expression: "{pushToken}",
                            includeIntoResult: true
                        }
                    ]
      },
      {type: "html", name: "info", html: "Please read these questions carefully and respond below.<br><br>Have you experienced a sore throat?<br><br>Have you experienced new uncontrolled cough that causes difficulty breathing (for students with chronic allergic/ asthmatic cough, a change in their cough from baseline)?<br><br>Have you experienced diarrhea, vomiting, or abdominal pain?<br><br>Have you experienced new onset of severe headache, especially with a fever?<br><br>Have you had close contact (within 6 feet of an infected person for at least 15 minutes) with a person with confirmed COVID-19?<br><br>Have you traveled to an area where the local, Tribal, territorial, or state health department is reporting large numbers of COVID-19 cases?<br><br>** IF NO TO ALL QUESTIONS, SELECT NO.**<br><br>** IF YES TO ANY OF THE QUESTIONS, SELECT YES.**"},
      {type: "boolean", name: "questionsValue", title: " ", isRequired: true},

       {
        type: "radiogroup",
         choices: [
          {
            value: "N",
            text: "No Fever"
           },
        ],
        colCount: 0,
        hasOther: true,
        isRequired: true,
        name: "temp",
        otherText: "Fever",
        title:  "Please select No Fever or Fever. If the fever is 100.4 F or greater, select Fever and input temperature reading in the text box below",
        placeHolder: "Please put in temperature reading",
         },
        {type: "text",name: "parentName", title: "Parent/Guardian Name", isRequired: true},
        {type: "html", name: "footer", html: "<b>If your child has any of the above symptoms or a fever, PLEASE HAVE YOUR CHILD STAY AT HOME.</b>"},
        
      ]
    
      
    };


    /*var jsonSurvey = {
     elements: [

     
      {type: "text",name: "studentId", title: "Student ID (Read Only)", readOnly: true,
      
        validators: [
                        {
                            type: "expression",
                            expression: "{companyName}",
                            includeIntoResult: true
                        },
                         {
                            type: "expression",
                            expression: "{entryTime}",
                            includeIntoResult: true
                        },
                        {
                            type: "expression",
                            expression: "{signatureUrl}",
                            includeIntoResult: true
                        },
                        {
                            type: "expression",
                            expression: "{studentName}",
                            includeIntoResult: true
                        }
                    ]
      },
       {
        type: "radiogroup",
         choices: [
          {
            value: "N",
            text: "No"
           },
        ],
        colCount: 0,
        hasOther: true,
        isRequired: true,
        name: "temp",
        otherText: "Yes",
        title:  "Does your child have or have they had a fever above 100.4 F. within the past 24 hours?"
         },
      {type: "boolean",name: "cough", title: "Does your child have a new onset or worsening cough or shortness of breath?"},
      {type: "html", name: "info", html: "<b>Does your child have any of the symptoms below (questions 4-10)?</b>"},
      {type: "boolean",name: "fever", title: "Chills?", isRequired: true},
      {type: "boolean",name: "sore", title: "Sore throat?", isRequired: true},
      {type: "boolean",name: "nose", title: "Runny Nose or nasal congestion", isRequired: true},
      {type: "boolean",name: "headache", title: "Headache?", isRequired: true},
      {type: "boolean",name: "fatigue", title: "Fatigue, muscle or body aches?", isRequired: true},
      {type: "boolean",name: "stomach", title: "Diarrhea, Nausea and/or vomiting", isRequired: true},
      {type: "boolean",name: "smell", title: "New onset loss of taste/smell", isRequired: true},
      {type: "html", name: "info", html: "<b> </b>"},
     
      {type: "boolean",name: "pastexp", title: "Has your child recently been diagnosed with COVID-19?", isRequired: true},
      {type: "boolean",name: "contact", title: "Has anyone in your household recently been in contact with someone diagnosed with COVID-19?", isRequired: true},
      {type: "boolean",name: "feverTime", title: "Has anyone in your household recently been in contact with someone with COVID-19 symptoms?", isRequired: true},
      {type: "boolean",name: "travel", title: "Due to the recent addition of the Chicago Department of Health Emergency Travel Order, have you traveled to any of the following locations with the past week? Alabama, Arkansas, Arizona, California, Florida, Georgia, Idaho, Iowa, Kansas, Louisiana, Mississippi, Missouri, Nebraska, North Carolina, North Dakota, South Carolina, South Dakota, Nevada, Oklahoma, South Carolina, Tennessee, Texas, Utah, or Puerto Rico.", isRequired: true},
     

      
        {type: "text",name: "parentName", title: "Full Name (adding your name to this field will serve as an electronic signature acknowledging the below information is true and correct).", isRequired: true}
      ]
    
      
    };

    console.log("HERE IS THE SURVEY_STRING");
    console.log(JSON.stringify(jsonSurvey));*/

       
      

        const model = new SurveyVue.Model(this.json);
        //const model = new SurveyVue.Model(jsonSurvey)
        model.onComplete.add(this.sendDataToServer);
        model.showCompletedPage = false;
        

        this.survey = model;
        this.survey.applyTheme="modern";
        this.survey.css.navigation.complete = "sv_complete_btn";
        if (this.questionValue == "N") 
        {
        this.survey.showQuestionNumbers = "off";
        }








    if (localStorage.getItem('jwsToken')) this.jwsToken = JSON.parse(localStorage.getItem('jwsToken'));



     var newDate = moment().tz("America/New_York").format("YYYY-MM-DD HH:mm:ss.SSS");
     this.entryTime = newDate;

    this.survey.data = {
    studentId: this.studentId,
    companyName: this.companyName,
    entryTime: this.entryTime,
    signatureUrl: this.signatureUrl,
    parentName: this.parentName,
    studentName: this.studentName,
    pushToken: this.pushToken
    }





        }

        }).catch(error => {

            console.log(error.response)
            this.$alert("Error survey cannot load (catch)","Error","error");

        });

    },

    sendDataToServer(survey) {
      //console.log(survey.data);
      //console.log("As String: " + JSON.stringify(survey.data));

      var json = survey.data;

      json["tempReading"] = json["temp-Comment"];
      delete json["temp-Comment"];

      console.log(json);

      this.postSurvey(json);

    },
    renameKey:function  ( obj, oldKey, newKey ) {
      obj[newKey] = obj[oldKey];
      delete obj[oldKey];
    },
    postSurvey(jsonObject) {


  //var jsonString = JSON.stringify(jsonObject)

  console.log(jsonObject);

  axios.post('https://api.conciergepadedu.com/api/Surveys/PostSurvey',jsonObject).then(response => {


      if (response.data.error) {

          console.log("ERROR");
          console.log('error', response.data.error);
           this.validSurvey = false;
           this.invalidSurvey = true;
           this.$alert("Survey NOT Added Successfully","Error","error");

      } else {

          console.log("SUCCESS");
          console.log('success', response.data);
          //this.survey.completedHtml = "Your text on completing survey";
          this.validSurvey = true;
          this.invalidSurvey = false;
          this.$alert("Survey Sent Successfully","Sent","success");

      } 

  

        }).catch(error => {
            console.log("CATCH");
            this.$alert("Survey NOT Added Successfully","Catch","error");
            this.validSurvey = false;
            this.invalidSurvey = true;
            console.log(error.response);
            console.log(error);



        });

 

  },


   }
   
}
</script>

<style>
.sv_complete_btn {
  background-color: green;
  color: white;
  font-size: 30px;
}

.sv_complete_btn:hover, .sv_complete_btn:focus {
  color: white;
  opacity: 0.8;
}
</style>